import {
  CREATE_WORKER_ONBOARDING_TEMPLATE_PATH,
  buildEditWorkerOnboardingTemplatePath,
} from '../../agency-pages/AgencyTasksPageInterfaces';

const buildEditJobberOnboardingTemplatePath = (templateId: string): string => {
  return buildEditWorkerOnboardingTemplatePath(templateId);
};

export {
  CREATE_WORKER_ONBOARDING_TEMPLATE_PATH,
  buildEditJobberOnboardingTemplatePath,
};
